import { Util } from "src/util/util";

export class Settings {
    public static minZoomScale = 0.02;
    public static maxZoomScale = 7;
    public static viewBorderThickness = 40;
    public static gridOffset = 100;
    public static worldSize = 50000;
    public static worldPolygon = Util.pathToMultiPolygon([0, 0, Settings.worldSize, 0, Settings.worldSize, Settings.worldSize, 0, Settings.worldSize]);
}
